var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitPaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_recruit_paper_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.029,
    height: 24.15,
    viewBox: "0 0 23.029 24.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121635",
    "data-name": "\\uD328\\uC2A4 121635",
    d: "M3197.586,1171.548s-7.982,6.911-11.3,8.414c5.224,12.351,13.215,14.17,13.215,14.17s4.621-4.294,9.814-10.323A17.869,17.869,0,0,1,3197.586,1171.548Z",
    transform: "translate(-3186.283 -1169.982)",
    fill: "#6b6b6b",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121636",
    "data-name": "\\uD328\\uC2A4 121636",
    d: "M3197.586,1149.571s-7.982,6.911-11.3,8.414c5.224,12.351,13.215,14.17,13.215,14.17s4.621-4.294,9.814-10.323A17.869,17.869,0,0,1,3197.586,1149.571Z",
    transform: "translate(-3186.283 -1149.571)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121637",
    "data-name": "\\uD328\\uC2A4 121637",
    d: "M3231.511,1202.573a19.7,19.7,0,0,0-2,1.448c-.662.5-1.325,1.006-1.983,1.514q-1.995,1.542-3.98,3.1c-.192.151.07.418.26.273q1.982-1.515,3.952-3.043c.656-.509,1.308-1.024,1.961-1.538a19.933,19.933,0,0,0,1.915-1.586A.1.1,0,0,0,3231.511,1202.573Z",
    transform: "translate(-3220.827 -1198.783)",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121638",
    "data-name": "\\uD328\\uC2A4 121638",
    d: "M3251.89,1226.549a5.437,5.437,0,0,0-.933.691c-.322.26-.638.528-.957.793-.622.518-1.246,1.033-1.866,1.553-1.253,1.052-2.513,2.1-3.752,3.168-.183.157.073.419.256.269,1.264-1.039,2.511-2.1,3.761-3.158.618-.522,1.232-1.049,1.848-1.573.315-.268.632-.534.943-.807a5.372,5.372,0,0,0,.831-.8C3252.084,1226.6,3251.972,1226.508,3251.89,1226.549Z",
    transform: "translate(-3240.184 -1221.054)",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121639",
    "data-name": "\\uD328\\uC2A4 121639",
    d: "M3268.662,1251.886a4.976,4.976,0,0,0-.987.72c-.305.253-.606.512-.907.77q-.948.81-1.891,1.624-1.888,1.628-3.772,3.26c-.191.166.079.445.269.283q1.894-1.621,3.781-3.251.944-.813,1.885-1.631c.313-.273.627-.544.937-.821a4.69,4.69,0,0,0,.806-.828C3268.834,1251.933,3268.738,1251.85,3268.662,1251.886Z",
    transform: "translate(-3255.711 -1244.587)",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121640",
    "data-name": "\\uD328\\uC2A4 121640",
    d: "M3295.089,1269.855a12.671,12.671,0,0,0-1.908,1.8q-.911.932-1.814,1.872l-1.85,1.917-.9.938-.47.491a1.366,1.366,0,0,0-.188.2c-.04.068-.025.151-.062.222a.084.084,0,0,0,.111.116c.078-.043.157-.036.232-.08a1.04,1.04,0,0,0,.178-.177l.474-.488.943-.979,1.809-1.877q.924-.959,1.844-1.922a12.43,12.43,0,0,0,1.7-1.938C3295.214,1269.9,3295.148,1269.816,3295.089,1269.855Z",
    transform: "translate(-3280.642 -1261.273)",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121641",
    "data-name": "\\uD328\\uC2A4 121641",
    d: "M3321.875,1302.884a13.775,13.775,0,0,0-1.727,1.659q-.831.846-1.66,1.692c-1.13,1.156-2.29,2.291-3.392,3.474-.152.162.078.409.239.252,1.157-1.129,2.264-2.315,3.394-3.472q.848-.868,1.693-1.74a13.361,13.361,0,0,0,1.585-1.727C3322.059,1302.944,3321.957,1302.826,3321.875,1302.884Z",
    transform: "translate(-3305.87 -1291.943)",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121642",
    "data-name": "\\uD328\\uC2A4 121642",
    d: "M3353.507,1330.008a4.247,4.247,0,0,0-.875.758c-.285.279-.563.564-.844.848-.548.553-1.088,1.114-1.632,1.671q-1.671,1.713-3.337,3.43c-.174.179.094.46.267.281q1.666-1.718,3.33-3.438c.554-.574,1.112-1.144,1.662-1.722.275-.289.553-.576.822-.87a4.132,4.132,0,0,0,.7-.86A.07.07,0,0,0,3353.507,1330.008Z",
    transform: "translate(-3335.326 -1317.141)",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitPaperIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_paper_icon.a68bd972ba3e35940e7e27777854a4b5.svg";
export { ForwardRef as ReactComponent };